// extracted by mini-css-extract-plugin
module.exports = {"navRegister":"AuthNav_navRegister__3g6m2","activeLink":"AuthNav_activeLink__2DbAX"};